export default {
    // this gets set in VIEW PRODUCTS page
    SET_ALL_PRODUCTS(state, data){
        state.products = data;
    },
    setQuickEditActive(state, isActive) {
        state.quickEditActive = isActive;
      },

};
